import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { ToastPosition } from 'src/app/models/common/toastPosition';

export const TOAST_STATE = {
  success: 'success-toast',
  warning: 'warning-toast',
  rejected: 'rejected-toast',
  caution: 'caution-toast',
  informationToast: 'information-toast',
};

@Injectable({
  providedIn: 'root'
})
export class ToastNotificationService {
  public showsToast$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public toastMessage$: BehaviorSubject<string> = new BehaviorSubject<string>('Default toast message');
  public toastState$: BehaviorSubject<string> = new BehaviorSubject<string>(TOAST_STATE.success);
  public toastPosition$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public timeOutVar: any;

  showToast(toastState: string, toastMessage: string, duration: number,position: ToastPosition): void {
    this.toastState$.next(toastState);
    this.toastMessage$.next(toastMessage);
    this.showsToast$.next(true);
    this.toastPosition$.next(`translate(${position.WidthPosition}vw, ${position.HeightPosition}vh)`);
    this.timeOutVar = setTimeout(() => {
      this.dismissToast();
    }, duration);    
  }

  clearToastTimeout(){
    clearTimeout(this.timeOutVar);
  }

  dismissToast(): void {
    this.showsToast$.next(false);
  }
}